import { ProgramsListPage } from '@components/buzzkuri/pages/ProgramsList'
import { BuzzkuriHead } from '@components/buzzkuri/shared/common/BuzzkuriHead'
import { ErrorPage } from '@components/buzzkuri/shared/common/ErrorPage'
import {
  NOT_FOUND_PAGE_PROPS,
  INTERNAL_SERVER_ERROR_PAGE_PROPS,
} from '@constants/common'
import { MetaData } from '@type/buzzkuri/api'
import { ProgramsListPageRes } from '@type/buzzkuri/programs'
import { ErrorStatus } from '@type/common'
import { getPagePropsReq } from '@utils/http'
import { GetServerSidePropsContext } from 'next'
import { ParsedUrlQuery } from 'querystring'
import React from 'react'

const Programs = (props: ProgramsListPageRes | ErrorStatus): JSX.Element => (
  <>
    {'errorStatus' in props ? (
      <ErrorPage
        {...(props.errorStatus === 404
          ? NOT_FOUND_PAGE_PROPS
          : INTERNAL_SERVER_ERROR_PAGE_PROPS)}
      />
    ) : (
      <>
        <BuzzkuriHead
          metaData={(props as ProgramsListPageRes).metaData as MetaData}
        />
        <ProgramsListPage
          {...(props as ProgramsListPageRes)}
          slugs="new_arrival"
        />
      </>
    )}
  </>
)
export default Programs

export async function getServerSideProps(
  context: GetServerSidePropsContext<ParsedUrlQuery>
): Promise<{
  props: ProgramsListPageRes | ErrorStatus
}> {
  return getPagePropsReq(
    context,
    '/api/programs/new_arrival',
    '新着プログラム(対面/オンライン)'
  ) as Promise<{
    props: ProgramsListPageRes | ErrorStatus
  }>
}
